import PortalIntegration from './PortalIntegration';

export function showDialog(url: string, event?: any) {

    var indexHtmlUrl = document.location.href.substring(0, document.location.href.indexOf('/index.html'));

    var redirectUrl = indexHtmlUrl + "/index.html?embedUrl=" + encodeURIComponent(url);

    Office.context.ui.displayDialogAsync(redirectUrl, {
        height: 75,
        width: 75,
        displayInIframe: true
    }, (result: Office.AsyncResult) => {

        if (event != null) {
            var dialog: Office.DialogHandler = result.value;
            dialog.addEventHandler(Office.EventType.DialogEventReceived, (arg) => {
                switch (arg.error) {
                    case 12006:
                        event.completed();
                        break;
                }
            });
        }

    });
}

export function showComposeDialog(username: string, event?: any) {
    showDialog(PortalIntegration.makeRequireLoginUrl(username, '/Compose'), event);
};





// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/FunctionFile.ts